<template>
  <div v-if="articles.length" class="articles-slider">
    <header class="articles-slider__header">
      <div class="articles-slider__title-wrap">
        <h3 class="articles-slider__title">{{ title }}</h3>
        <a v-if="link" :href="link" class="articles-slider__more">
          {{ $t('see_all') }}
        </a>
      </div>
      <div class="articles-slider__navigation">
        <div class="swiper-button-prev" :class="[transliterate(title) + '-prev']" slot="button-prev"></div>
        <div class="swiper-button-next" :class="[transliterate(title) + '-next']" slot="button-next"></div>
      </div>
    </header>
    <swiper class="swiper" :options="swiperOption">
      <swiper-slide class="swiper-item" v-for="(item, i) in articles" :key="i">
        <ArticlesSliderItem
          :block-name="titleAnalytics"
          :position="i + 1"
          :link="item.article_link"
          :category="item.article_category"
          :date="item.article_date"
          :description="item.article_description"
          :img="item.article_img"
          :title="item.article_title"
        />
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import { transliteration } from '@/mixins/transliteration'
import { isTouch } from '@/mixins/isTouchDevice'
import ArticlesSliderItem from './ArticlesSliderItem'
import { getArticleMicrodata } from '@/helpers/microdata/getArticleMicrodata'
import { mapActions } from 'vuex'
import { getIsoDateStr } from '@/helpers/getIsoDateStr'

export default {
  name: 'ArticlesSlider',
  mixins: [transliteration, isTouch],
  props: {
    title: {
      type: String,
      default: ''
    },
    link: {
      type: String,
      default: ''
    },
    articles: {
      type: Array,
      default: () => []
    },
    titleAnalytics: {
      type: String,
      default: ''
    }
  },
  components: {
    ArticlesSliderItem,
    Swiper,
    SwiperSlide
  },
  data () {
    return {
      swiperOption: {
        watchSlidesVisibility: true,
        spaceBetween: 30,
        slidesPerView: 1.5,
        navigation: {
          nextEl: '.' + this.transliterate(this.title) + '-next',
          prevEl: '.' + this.transliterate(this.title) + '-prev'
        },
        simulateTouch: !isTouch,
        touchStartPreventDefault: false,
        preloadImages: false,
        lazy: true,
        breakpoints: {
          319: {
            spaceBetween: 30,
            slidesPerView: 1.2
          },
          550: {
            spaceBetween: 30,
            slidesPerView: 2.2
          },
          769: {
            spaceBetween: 20,
            slidesPerView: 3
          },
          1100: {
            spaceBetween: 20,
            slidesPerView: 4
          }
        }
      }
    }
  },
  methods: {
    ...mapActions('microdata', ['APPEND_ITEM_TO_LIST']),
    addMicrodata () {
      if (this.articles.length) {
        this.APPEND_ITEM_TO_LIST({
          '@type': 'ItemList',
          'name': this.title,
          'itemListElement': this.articles.map(article => {
            return getArticleMicrodata({
              headline: article.article_title,
              images: article.article_img,
              datePublished: getIsoDateStr(article.article_date)
            })
          })
        })
      }
    }
  },
  created () {
    this.addMicrodata()
  }
}
</script>

<style scoped lang="sass">
@import "../../../../node_modules/swiper/css/swiper.min.css"

@import "../../../styles/swiper/swiper"

.articles-slider ::v-deep
  .swiper-wrapper
    align-items: flex-start

.articles-slider__header
  padding: 0 15px

.swiper-container
  padding: 0 15px

.articles-slider__header
  display: flex
  flex-flow: row nowrap
  justify-content: space-between
  align-items: center
  margin-bottom: 15px

  +mmin($tablet)
    margin-bottom: 30px

.articles-slider__title-wrap
  display: flex
  flex-flow: row wrap
  align-items: baseline
  justify-content: space-between
  width: 100%

  +mmin($tablet)
    width: auto
    justify-content: flex-start

.articles-slider__title
  font-size: 18px
  font-weight: 500
  padding: 0
  margin: 0

  +mmin($tablet)
    font-size: 24px

.articles-slider__more
  color: $main-color
  font-size: 14px
  font-weight: 400 //Rubik 300

  +mmin($tablet)
    font-size: 16px
    margin-left: 20px

  &:hover,
  &:focus,
  &:active
    color: $main-color--hover

.articles-slider__navigation
  display: none
  position: relative
  width: 70px

  +mmin($tablet)
    display: block
</style>
